<template>
    <div class="col-md-12">
        <div class="ln_solid"></div>
        <br />
        <form @submit.prevent="searchData()" role="form">
            <div class="row">
                <div class="col-2">

                    <input type="text"
                           class="form-control"
                           v-model="pagingInfo.search"
                           placeholder="Subject/Title" />

                </div>
                <div class="col-2">

                    <input type="date"
                           class="form-control"
                           v-model="pagingInfo.datestart"
                           placeholder="Date Start" />

                </div>
                <div class="col-2">

                    <input type="date"
                           class="form-control"
                           v-model="pagingInfo.dateend"
                           placeholder="Date End" />

                </div>
                <div class="col-2">

                    <input type="text"
                           class="form-control"
                           v-model="pagingInfo.reportnumber"
                           placeholder="Report Number" />

                </div>
                <div class="col-2">

                    <select id="region"
                            class="form-control"
                            v-model="pagingInfo.region">
                       
                        <option value="">Select Region</option>
                        <option value="D010">NCR</option>
                        <option value="RECSC20210001">CAR</option>
                        <option value="D011">RO1</option>
                        <option value="D012">RO2</option>
                        <option value="D013">RO3</option>
                        <option value="D014">RO4</option>
                        <option value="RECSC20210002">RO4B</option>
                        <option value="D015">RO5</option>
                        <option value="D016">RO6</option>
                        <option value="D017">RO7</option>
                        <option value="D018">RO8</option>
                        <option value="D019">RO9</option>
                        <option value="D020">RO10</option>
                        <option value="D021">RO11</option>
                        <option value="D022">RO12</option>
                        <option value="RECSC20120006">RO13</option>
                        <option value="RECSC20230002">BARMM</option>
                        <option value="D003">D2</option>
                        <option value="RECSC20090004">D4</option>
                        <option value="RECSC20070004">D5</option>
                        <option value="RECSC20190001">D6</option>
                    </select>

                </div>

                

            </div>
            <hr />
            <div class="row">
                <div class="col-2">
                    <input type="date"
                           class="form-control"
                           v-model="pagingInfo.reportdate"
                           placeholder="Report Date" />
                </div>
                <div class="col-2">

                    <button type="submit" class="btn btn-info ">
                        <strong>Search</strong>
                    </button>&nbsp;
                    <button type="button" v-on:click="clearControls()" class="btn btn-primary">Clear</button>

                </div>
            </div>
        </form>
        <br />
        <div class="box">
            <div class="box-header"></div>
            <div class="box-body table-responsive no-padding">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <!--<th>ID</th>-->
                            <th>
                                <a>Subject</a>
                            </th>
                            <th>
                                <a>Report No.</a>
                            </th>
                            <th>
                                <a>Report Date</a>
                            </th>
                            <th>Created By</th>
                            <th>
                                <a>Date Created</a>
                            </th>
                            <th>Updated By</th>
                            <th>
                                <a>Date Updated</a>
                            </th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(doc, index) in documents" :key="doc.id">
                            <!--<td><p ng-hide="doc.n4sh == 'Y'">{{doc.id}}</td>-->
                            <td>{{ doc.title | capitalize }}</td>
                            <td>{{ doc.reportNo }}</td>
                            <td>{{ doc.reportDate | formatDate }}</td>
                            <td>{{ doc.createdBy }}</td>
                            <td>{{ doc.dateCreated | formatDate }}</td>
                            <td>{{ doc.updatedBy }}</td>
                            <td>{{ doc.dateUpdated | formatDate }}</td>
                            <td v-if="$store.getters.CRAD">
                                <TheDropDownButton>
                                    <btn @click.native="deleteDoc(doc.id, index)"
                                         icon="fa fa-trash"
                                         title="Delete"></btn>
                                    <btn @click.native="editDocument(doc.id)"
                                         icon="fa fa-pencil-alt"
                                         title="Edit"></btn>
                                    <btn @click.native="viewLogs(doc.id)"
                                         icon="fa fa-cogs"
                                         title="View Download Logs"></btn>
                                    <btn @click.native="requestlinkdownload(doc.id)"
                                         icon="fa fa-cloud-download-alt"
                                         title="Export"></btn>
                                    <btn @click.native="addtoMerge(doc)"
                                         icon="fa fa-code-branch"
                                         title="Merge Record"></btn>
                                    <btn @click.native="preview(doc.id)"
                                         icon="fa fa-search"
                                         title="Preview File Attached"></btn>
                                    <btn @click.native="getfile(doc.id)"
                                         icon="fa fa-download"
                                         title="Download File"></btn>
                                    <btn @click.native="More(doc)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                    <btn @click.native="startLink(doc)"
                                         icon="fa fa-compress"
                                         title="Enable Link Mode"></btn>
                                </TheDropDownButton>
                            </td>
                            <td v-else-if="$store.getters.VIEWER">
                                <TheDropDownButton>
                                    <btn @click.native="getfile(doc.id)"
                                         icon="fa fa-download"
                                         title="Download File"></btn>
                                    <btn @click.native="More(doc)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                    <btn @click.native="preview(doc.id)"
                                         icon="fa fa-search"
                                         title="Preview File Attached"></btn>
                                </TheDropDownButton>
                            </td>
                            <td v-else>
                                <TheDropDownButton>
                                    <btn @click.native="getfile(doc.id)"
                                         icon="fa fa-download"
                                         title="Download File"></btn>

                                    <btn @click.native="More(doc)"
                                         icon="fa fa-expand-alt"
                                         title="View Linkages"></btn>
                                    <btn @click.native="preview(doc.id)"
                                         icon="fa fa-search"
                                         title="Preview File Attached"></btn>
                                </TheDropDownButton>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot></tfoot>
                </table>
                <div v-show="totalitems == 0" class="alert alert-warning">
                    <p>Found no result try again</p>
                </div>
            </div>
            <div class="box-footer clearfix">
                <b-pagination v-model="pagingInfo.page"
                              v-on:input="fetchData()"
                              :total-rows="totalitems"
                              :per-page="pagingInfo.itemsPerPage"
                              first-text="First"
                              prev-text="Prev"
                              next-text="Next"
                              last-text="Last"></b-pagination>
            </div>
        </div>

        <b-modal id="editDoc"
                 title="Edit Document"
                 scrollable
                 hide-footer
                 size="lg">
            <docedit v-bind:id="documentid" v-on:done-edit="doneEdit()" />
        </b-modal>
        <b-modal id="edit"
                 title="Change Attached Document"
                 scrollable
                 hide-footer
                 size="md">
            <attachEdit v-bind:id="documentid"
                        v-bind:url="urlAttach"
                        v-on:done-edit-att="doneEditAtt()" />
        </b-modal>
        <b-modal id="linkpopupdoc" size="xl" scrollable hide-footer>
            <LinkComponentPopDoc v-bind:id="linkid"
                                 v-bind:linkdescription="linkdescription" />
        </b-modal>
        <b-modal id="mergerecorddc" 
                 size="md"
                 hide-footer
                 ref="merger"
                 no-close-on-esc="true"
                 no-close-on-backdrop="true"
                 hide-header-close="true">
            <MergePopUpdc v-bind:obj1ID="obj1Id"
                          v-bind:obj2ID="obj2Id"
                          v-bind:obj1Desc="obj1description"
                          v-bind:obj2Desc="obj2description"
                          v-bind:objType="objType"
                          v-on:done="done()"
                          v-on:cancel="cancel()" />
        </b-modal>
        <b-modal id="preview"
                 title="Preview"
                 scrollable
                 hide-footer
                 size="xl">
            <viewer v-bind:Id="idforviewer"
                    v-bind:html="htmlforviewer"/>
        </b-modal>
        <b-modal id="loglist" size="xl" title="Download Logs" scrollable hide-footer>
                <DocumentLogs v-bind:id="logid" v-bind:url="urlLog" />
        </b-modal>
    </div>
</template>

<script>
    import {
        authHeader,
        responseCheck,
        RecordURL,
        notifyHelper,
        downloadblob,
        RequestLink,
        DataURL
    } from "../helper";
    import docedit from "./edit/Document";
    import attachEdit from "./master/editAttachment";
    import btn from "./buttons/iconButton";
    import LinkComponentPopDoc from "./link/linkcomponent";
    import MergePopUpdc from "./master/recordMerge";
    //import TheDropDownButton from "./buttons/DropDownButton";
    import instance from "../helper/http";
    import viewer from "./master/viewer";
    import DocumentLogs from "./master/downloadLogs.vue"
    export default {
        data() {
            return {
                documents: [],
                pagingInfo: {
                    page: 1,
                    sortBy: "DateCreated",
                    reverse: false,
                    search: "",
                    reportnumber: "",
                    region: "",
                    datestart: "",
                    dateend: "",
                    reportdate: ""
                },
                totalitems: null,
                documentid: "",
                urlAttach: "editAttachment",
                linkid: "",
                linkdescription: "",
                obj1Id: "",
                obj2Id: "",
                objType: "",
                obj1description: "",
                obj2description: "",
                hasfirst: false,
                htmlforviewer: "",
                idforviewer : "",
                logid: "",
                urlLog: "getdocumentdownloadlogs"
                
            };
        },
        components: {
            docedit,
            attachEdit,
            btn,
            LinkComponentPopDoc,
            MergePopUpdc,
            viewer,
            DocumentLogs
            //TheDropDownButton,
        },
        methods: {
            async requestlinkdownload(id) {
                await RequestLink(id);
            },
            fetchData() {
                instance
                    .get(RecordURL + "getdoc", {
                        headers: authHeader(),
                        params: this.pagingInfo,
                    })
                    .then((response) => {
                        this.documents = response.data.data;
                        this.totalitems = response.data.count;
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            searchData() {
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            More: function (data) {
                var additional = data.title;
                additional = additional.replace(/\//g, "-");
                // this.$router.push({
                //   name: "Links",
                //   params: { id: data.id, description: additional },
                // });

                this.linkid = data.id;
                this.linkdescription = additional;
                this.$bvModal.show("linkpopupdoc");
            },
            sort: function (sortBy) {
                if (sortBy === this.pagingInfo.sortBy) {
                    this.pagingInfo.reverse = !this.pagingInfo.reverse;
                } else {
                    this.pagingInfo.sortBy = sortBy;
                    this.pagingInfo.reverse = false;
                }
                this.pagingInfo.page = 1;
                this.fetchData();
            },
            download: function (docID, filename, type) {
                //window.open(RecordURL + 'downloadcopy?docID=' + docID, '_blank', '')

                instance
                    .get(RecordURL + "downloadcopy?docID=" + docID, {
                        headers: authHeader(),
                        responseType: "blob",
                    })
                    .then((response) => {
                        downloadblob(filename, response.data, type);
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            preview(id) {
                instance
                    .get(DataURL + "preview?Id=" + id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (!response.data.error) {
                            this.idforviewer = id;
                            this.htmlforviewer = response.data.data;
                            this.$bvModal.show("preview");
                        } else {
                            notifyHelper("info", response.data.message);
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            getfile: function (id) {
                instance
                    .get(RecordURL + "checkfiles?docID=" + id, {
                        headers: authHeader(),
                    })
                    .then((response) => {
                        if (response.data.withfiles) {
                            this.download(id, response.data.filename, response.data.type);
                        } else {
                            this.getFullText(id);
                        }
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            getFullText(id) {
                instance
                    .get(RecordURL + "fulltext?docID=" + id, {
                        headers: authHeader(),
                        responseType: "blob",
                    })
                    .then((response) => {
                        downloadblob(id + ".pdf", response.data, "application/pdf");
                    })
                    .catch(function (error) {
                        responseCheck(error.response.status);
                    });
            },
            editDocument: function (doc) {
                this.documentid = doc;
                //modal
                this.$bvModal.show("editDoc");
            },
            editAttach: function (doc) {
                this.documentid = doc;
                //modal
                this.$bvModal.show("edit");
            },
            doneEditAtt() {
                this.$bvModal.hide("edit");
            },
            doneEdit() {
                this.$bvModal.hide("editDoc");
            },
            startLink: function (doc) {
                this.$bvModal
                    .msgBoxConfirm("Are you sure you want to enable link mode?.", {
                        title: "Enable Link Mode?",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        okTitle: "Yes",
                        cancelTitle: "No",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            this.$store.commit("enablelinkMode", {
                                id: doc.id,
                                type: "DC",
                                description: doc.title,
                            });
                        }
                    });
            },
            cancel() {
                this.$bvModal.hide("mergerecorddc");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
            },
            done() {
                this.$bvModal.hide("mergerecorddc");
                this.hasfirst = false;
                this.obj1Id = "";
                this.obj2Id = "";
                this.obj1description = "";
                this.obj2description = "";
                this.fetchData();
            },
            addtoMerge(data) {
                var additional =
                    (data.title ? data.title : "");
                additional = additional.replace(/\//g, "-");
                if (this.hasfirst) {
                    if (this.obj1Id == data.id) {
                        notifyHelper("info", "Cannot merge the same person");
                    }
                    else {
                        this.obj2description = additional;
                        this.obj2Id = data.id;
                        this.objType = "DC"
                        //open the popup
                        this.$bvModal.show("mergerecorddc");
                    }

                } else {
                    this.obj1description = additional;
                    this.obj1Id = data.id;
                    this.hasfirst = true;
                    notifyHelper(
                        "success",
                        "Add to merging of record, please choose another record to merge"
                    );
                }
            },
            deleteDoc: function (id, index) {
                this.$bvModal
                    .msgBoxConfirm("Are you sure you want to enable delete?.", {
                        title: "Delete?",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: "Yes",
                        cancelTitle: "No",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            instance
                                .get(RecordURL + "deleteDoc?docID=" + id, {
                                    headers: authHeader(),
                                })
                                .then((response) => {
                                    if (response.data.error) {
                                        notifyHelper("error", response.data.message);
                                    } else {
                                        notifyHelper("success", response.data.message);
                                        this.documents.splice(index, 1)
                                    }
                                })
                                .catch(function (error) {
                                    responseCheck(error.response.status);
                                });
                        }
                    });
            },
            clearControls() {
                

                this.pagingInfo.search = "";
                this.pagingInfo.reportnumber = "";
                this.pagingInfo.datestart = "";
                this.pagingInfo.dateend = "";
                this.pagingInfo.region = "";
                this.pagingInfo.reportdate = "";

            },
            viewLogs(id){
                this.logid = id;
                this.$bvModal.show("loglist");
            }
        },
    };
</script>
